const commonBizLines = [
    {
        name: 'open-frame',
        SimplePermissions: ['/fe/purse/*']
    }, {
        name: 'open-presalechat',
        SimplePermissions: ['/fe/preSaleService/*']
    }, {
        name: 'open-info',
        SimplePermissions: ['/fe/info/*']
    }
];

const BizLineMap = { 'open-jingjiu': 'jiujing', 'open-jijiu': 'jijiu', 'open-cheliang': 'chepiao', 'open-gentuanyou': 'gty', 'lvyou-ticket': 'ticket', 'open-wenchuang': 'wenchuang' };

const bizLineCommonMenus = ['academy', 'policyrule'];
const bizLinePrivateMenus = { 'lvyou-ticket': ['ticketold/*'] };
const permissionPreFix = '/fe/';

const fePermissionReg = /^\/fe\/.*/;

class SimplePermissions {
    private permissions: Array<string>;
    constructor(private bizLineAuthInfos: Array<bizLineAuthInfos>) {
        this.addCommonLines();
    }

    addCommonLines() {
        if (this.bizLineAuthInfos && this.bizLineAuthInfos.length) {
            this.bizLineAuthInfos.forEach((line) => {
                let bizLineName = line.bizline;
                let linePath = BizLineMap[bizLineName];
                if (linePath && line.simplePermissions && line.simplePermissions.length) {
                    let preFix = permissionPreFix + linePath + '/';
                    bizLineCommonMenus.forEach((menuPath) => {
                        line.simplePermissions.push(preFix + menuPath);
                    });
                    let privateMenus = bizLinePrivateMenus[bizLineName];
                    if (privateMenus && privateMenus.length) {
                        privateMenus.forEach(menuPath => {
                            line.simplePermissions.push(permissionPreFix + menuPath);
                        });
                    }
                }
            });
            commonBizLines.forEach((line) => {
                this.bizLineAuthInfos.push({
                    bizline: line.name,
                    simplePermissions: line.SimplePermissions
                });
            });
        }
    }

    getPermissions(): Array<string> {
        let result: Array<string> = [];
        this.bizLineAuthInfos.forEach((bizLineInfo) => {
            let simplePermissions = bizLineInfo.simplePermissions || [];
            simplePermissions.filter((permission) => {
                if (fePermissionReg.test(permission)) {
                    if (!result.includes(permission)) {
                        result.push(permission);
                    }
                }
            });
        });
        return result;
    }
}

const WILD_CARD = '*';

class PathNode {
    children: any;
    constructor(name) {
        if (name !== WILD_CARD) {
            this.children = {};
        } else {
            this.children = null;
        }
    }
}

class PermissionTree {
    rootNode: PathNode;
    constructor(private permissions: Array<string>) {
        this.rootNode = new PathNode('');
        permissions.forEach((urlPattern) => {
            let pathSegments = urlPattern.substring(3, urlPattern.length).split('/');
            let currentNode = this.rootNode;
            for (let depth = 1; depth < pathSegments.length; ++depth) {
                if (!currentNode.children) {
                    break;
                }
                let pathName = pathSegments[depth];
                if (!currentNode.children[pathName]) {
                    currentNode.children[pathName] = new PathNode(pathName);
                }
                currentNode = currentNode.children[pathName];
            }
        });
    }
}

class Customs {
    constructor(private permissionTree: PermissionTree) {
    }

    check(path: string): boolean {
        let paths = path.split('/');
        let currentNode = this.permissionTree.rootNode;
        for (let i = 1; i < paths.length; ++i) {
            let currentPath = paths[i];
            if (!currentNode.children) {
                return false;
            }
            if (currentNode.children[WILD_CARD]) {
                return true;
            }
            if (!currentNode.children[currentPath]) {
                return false;
            }
            currentNode = currentNode.children[currentPath];
        }
        return true;
    }
}

export class CustomsBuilder {
    static buildCustoms(bizLineAuthInfos: Array<bizLineAuthInfos>) {
        let sPermission = new SimplePermissions(bizLineAuthInfos);
        let permissionTree = new PermissionTree(sPermission.getPermissions());
        return new Customs(permissionTree);
    }
}



// WEBPACK FOOTER //
// ./src/Auth/SimplePermissions.ts